export default {
  name: {
    id: 'rm_metal_germanium_name',
    defaultMessage: 'Germanium',
  },
  smartphoneLabel: {
    id: 'rm_metal_germanium_smartphone_label',
    defaultMessage: 'Trace (invisible to the naked eye)',
  },
  whatItDoesText: {
    id: 'rm_metal_germanium_what_it_does',
    defaultMessage:
      'Germanium is a semiconductor used in high-performance electronics, it helps control and speed up the flow of electricity in electronics, and it is essential to optical fibres and infrared optics. In smartphones, it is mainly linked to electronic and optical components rather than visible parts of the device.',
  },
  extractionText1: {
    id: 'rm_metal_germanium_extraction_p1',
    defaultMessage:
      'Germanium has no mines of its own. It exists only in tiny traces inside zinc ores and certain coal deposits, and is recovered as a byproduct when zinc concentrate is smelted: the germanium is captured as an intermediate concentrate and then purified to the very high grade electronics needed. Because so few smelters bother to recover it, most germanium in the ore is simply lost.',
  },
  quickFactText: {
    id: 'rm_metal_germanium_quick_fact',
    defaultMessage:
      'Almost all germanium feeds the digital world. But there is no mine to open when demand rises: this invisible metal is recovered in tiny amounts from zinc processing and coal ash, so supply cannot be increased quickly.',
  },
  envSummaryText: {
    id: 'rm_metal_germanium_env_summary',
    defaultMessage:
      'Germanium is usually recovered as a by-product of zinc or coal processing, so it does not require a dedicated mine. However, its purification uses chemical treatments such as acid leaching, chlorination and distillation. Recovery from coal has a higher ecological footprint than recovery from zinc-based sources or recycling.',
  },
  envWaterText: {
    id: 'rm_metal_germanium_env_water_text',
    defaultMessage:
      'Recovering germanium from coal fly ash can involve sulfuric acid leaching and several chemical treatment steps. Wastewater and chlorine-containing effluents must be treated on site, both to recover germanium and to limit environmental pollution.',
  },
  envSoilText: {
    id: 'rm_metal_germanium_env_soil_text',
    defaultMessage:
      'In Lincang, West Yunnan, more than 40 years of coal mining and germanium processing have been linked to releases of natural radionuclides into the environment. Reports identify long-term public health concerns in the region.',
  },
  envClimateText: {
    id: 'rm_metal_germanium_env_climate_text',
    defaultMessage:
      'Recycling and recovery from zinc-based sources have a lower carbon footprint than recovery from coal.',
  },
  humanSummaryText: {
    id: 'rm_metal_germanium_human_summary',
    defaultMessage:
      'Germanium has few social impacts documented separately from zinc and coal production. However, more than 40 years of coal mining and germanium processing in West Yunnan have been linked to releases of natural radionuclides and long-term public health concerns.',
  },
  humanHealthText: {
    id: 'rm_metal_germanium_human_health_text',
    defaultMessage:
      'Germanium itself is generally considered non-toxic, but some compounds may damage organs or affect fertility after prolonged exposure. Workers can inhale fumes and dust during extraction and purification. Germane gas is highly toxic and can cause fatal damage to the blood, heart, liver and kidneys at high concentrations.',
  },
  geoSummaryText: {
    id: 'rm_metal_germanium_geo_summary',
    defaultMessage:
      'Germanium is a pressure point. It is produced in very few countries, and China dominates every stage. In August 2023 China put germanium exports under licence, and in December 2024 it banned all germanium exports to the United States outright.',
  },
  geoDugText: {
    id: 'rm_metal_germanium_geo_dug_text',
    defaultMessage:
      "China is the leading producer and extracts about 68% of the world's germanium. No detailed country-by-country figures are published, because most producers do not report their output..",
  },
  geoProcessedText: {
    id: 'rm_metal_germanium_geo_processed_text',
    defaultMessage:
      "China's grip is even tighter at the processing stage, handling roughly 83% of the world's refined germanium. China is the dominant refiner for almost every strategic mineral it tracks.",
  },
  geoLeverageText: {
    id: 'rm_metal_germanium_geo_leverage_text',
    defaultMessage:
      'China has used germanium as a lever: export licensing from August 2023, then a full ban on exports to the United States from December 2024.',
  },
  supplySummaryText: {
    id: 'rm_metal_germanium_supply_summary',
    defaultMessage:
      'Germanium has a supply bottleneck. It is recovered as a by-product of zinc processing and from coal ash, rather than mined independently. Meeting future demand would require additional recovery and refining capacity at these processing facilities. Known reserves are difficult to quantify, and a strong growth is projected in digital-sector demand..',
  },
  supplyReservesText: {
    id: 'rm_metal_germanium_supply_reserves_text',
    defaultMessage:
      'Global germanium reserves are difficult to quantify because germanium is never mined on its own and occurs only in trace amounts in zinc ores and coal. Projections suggest that, at current consumption levels, germanium reserves could be exhausted in around 14 years, by approximately 2037. Building recovery and refining capacity outside China takes years.',
  },
  supplyDemandText: {
    id: 'rm_metal_germanium_supply_demand_text',
    defaultMessage:
      'Germanium demand from clean-energy technologies is projected to fall by 30% between 2025 and 2050, but this covers solar PV cells only. Since most germanium demand is technology-driven, the projection is incomplete. The French Agency for Ecological Transition (ADEME) projects that germanium use in France’s digital sector could rise by 74% by 2030 and 370% by 2050, driven by fibre-optic networks and telecommunications. Digital infrastructure, robotics and drones could offset this decline.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_germanium_recycling_summary',
    defaultMessage:
      'Germanium is barely recycled: its end-of-life recycled-input rate is about 2%, and what little is recovered comes from scrap infrared optics such as old phones, not from a dedicated system. There is currently no industrial-scale recycling of germanium and no real market for recycled germanium.',
  },
  recyclingInputText: {
    id: 'rm_metal_germanium_recycling_input_text',
    defaultMessage:
      'Around 30% of global germanium supply can come from recycled material, but this figure is driven almost entirely by manufacturing scrap. The end-of-life recycled input rate is only about 2%.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_germanium_recycling_outlook_text',
    defaultMessage:
      'The recycling outlook is poor. Germanium is spread in tiny quantities across many components, its scrap value is low, and no industrial recovery process operates at scale, so without policy support the recycled share is likely to stay near zero.',
  },
  footnote1Text1: {
    id: 'rm_metal_germanium_footnote_1_p1',
    defaultMessage:
      'Germanium figures are not reported in the usual USGS 2025 source for production data. They instead come from ADEME’s 2024 study. As germanium is a by-product metal, these figures refer to production at the refining stage. “Top Mining Countries” should therefore be understood as “Top Refining Countries”, because germanium is recovered mainly as a by-product of zinc smelting and from certain coal deposits.',
  },
  mine0Region: {
    id: 'rm_metal_germanium_mine0_region',
    defaultMessage: 'Lincang',
  },
  mine1Region: {
    id: 'rm_metal_germanium_mine1_region',
    defaultMessage: 'Xilinhot',
  },
  mine2Region: {
    id: 'rm_metal_germanium_mine2_region',
    defaultMessage: 'Olen',
  },
} as const
